import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { AuthButton, Authorization, TokenContext } from "../App";

import s from '../styles/App.module.css'
import photo from '../assets/photo/Профиль.png';
import cartIcon from '../assets/photo/Корзина.png';

interface CustomJwtPayload {
  username?: string;
  [key: string]: unknown;
}

const ProfileButton = () => {
  const tokenContext = useContext(TokenContext);
  const authContext = useContext(Authorization);
  const authButtonContext = useContext(AuthButton);

  const navigate = useNavigate();
  const [name, setName] = useState<string>('');

  useEffect(() => {
    const token = tokenContext?.token;

    if (token) {
      try {
        const decoded = jwtDecode<CustomJwtPayload>(token);
        if (decoded.username) {
          setName(decoded.username);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [tokenContext?.token]);

  function openLogin() {
    authButtonContext?.setAuthBut(true);
  }

  function openProfile() {
    navigate('/profile');
  }

  return (
    <div className={s.nav_right}>
      {/* Новая обертка для рамки */}
      <div className={s.nav_controls}>
        <div className={s.cart_wrapper} onClick={() => navigate('/buy')}>
          <img src={cartIcon} className={s.cart_icon} alt="Корзина" />
        </div>

        {!authContext?.auth ? (
          <button onClick={openLogin} className={s.login_button}>
            <span>Войти</span>
            <img src={photo} alt="Профиль" />
          </button>
        ) : (
          <button onClick={openProfile} className={s.login_button}>
            <span>{name}</span>
            <img src={photo} alt="Профиль" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileButton;